import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";

const menuItems = [
  { label: "Home", href: "#top" },
  { label: "About", href: "#about" },
  {
    label: "Services",
    href: "#services",
    children: [
      { label: "Digital Solutions", href: "#digital" },
      { label: "Business Solutions", href: "#business" },
      { label: "Supply & Trading Solutions", href: "#supply" },
    ],
  },
  { label: "Contact", href: "#contact" },
];

function Header() {
  const headerRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    let lastScroll = 0;
    const onScroll = () => {
      const header = headerRef.current;
      if (!header) return;
      const currentScroll = window.scrollY;
      if (currentScroll > 200) {
        if (currentScroll < lastScroll) header.classList.add("sticky");
        else header.classList.remove("sticky");
      } else if (currentScroll === 0) {
        header.classList.remove("sticky");
      }
      lastScroll = currentScroll;
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleDropdown = (label) => {
    setOpenDropdown((prev) => (prev === label ? null : label));
  };

  return (
    <>
      <header
        ref={headerRef}
        className="header-area header-one transparent-header"
      >
        <div className="header-navigation">
          <div className="container-fluid">
            <div className="primary-menu">
              <div className="site-branding">
                <a href="#top" className="brand-logo">
                  <img
                    src="/img/logoFooter.svg"
                    alt="Lozrian"
                    style={{ filter: "brightness(0) invert(1)" }}
                    height={35}
                  />
                </a>
              </div>
              <div className={`theme-nav-menu ${menuOpen ? "menu-on" : ""}`}>
                <div className="theme-menu-top d-block d-xl-none">
                  <div className="site-branding">
                    <a href="#top" className="brand-logo">
                      <img src="/img/logo.svg" alt="Lozrian" />
                    </a>
                  </div>
                </div>
                <nav className="main-menu">
                  <ul>
                    {menuItems.map((item) => (
                      <li
                        key={item.label}
                        className={`menu-item ${
                          item.children ? "has-children" : ""
                        }`}
                      >
                        <a href={item.href} onClick={() => setMenuOpen(false)}>
                          {item.label}
                          {item.children && (
                            <span
                              className={`dd-trigger ${
                                openDropdown === item.label
                                  ? "sub-menu-open"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                toggleDropdown(item.label);
                              }}
                            >
                              <i className="far fa-angle-down"></i>
                            </span>
                          )}
                        </a>
                        {item.children && (
                          <ul
                            className="sub-menu"
                            style={{
                              display:
                                openDropdown === item.label
                                  ? "block"
                                  : undefined,
                            }}
                          >
                            {item.children.map((child) => (
                              <li key={child.label}>
                                <a
                                  href={child.href}
                                  onClick={() => setMenuOpen(false)}
                                >
                                  {child.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
                <div className="theme-nav-button mt-20 d-block d-md-none">
                  <a href="#contact" className="theme-btn gradient-btn">
                    Contact Us<i className="far fa-arrow-right"></i>
                  </a>
                </div>
              </div>
              <div className="nav-right-item">
                <div className="search-button">
                  <div
                    className="search-btn"
                    onClick={() => setSearchOpen(true)}
                  >
                    <i className="far fa-search"></i>
                  </div>
                </div>
                <div className="nav-button d-none d-md-block">
                  <a href="#contact" className="theme-btn gradient-btn">
                    Contact Us<i className="far fa-arrow-right"></i>
                  </a>
                </div>
                <div
                  className={`navbar-toggler ${menuOpen ? "active" : ""}`}
                  onClick={() => setMenuOpen((prev) => !prev)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        className={`offcanvas__overlay ${menuOpen ? "overlay-open" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      <Modal
        show={searchOpen}
        onHide={() => setSearchOpen(false)}
        centered
        className="search-modal"
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-group">
            <input
              type="search"
              className="form_control"
              placeholder="Search here"
              name="search"
            />
            <label>
              <i className="fa fa-search"></i>
            </label>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default Header;
